import * as React from 'react';
// @ts-ignore
import { useIframe } from 'CourseAuthoring/generic/hooks/context/hooks';
import { BlockTypes } from '../constants';
import { AspectsSidebar } from './AspectsSidebar';
import { castToBlock } from '../types';
export function UnitPageSidebar(_ref) {
  let {
    blockId,
    unitTitle,
    xBlocks
  } = _ref;
  const {
    sendMessageToIframe
  } = useIframe();
  const contentLists = [];
  if (xBlocks && xBlocks.length) {
    const blocks = castToBlock(xBlocks);
    contentLists.push({
      title: '',
      blocks: blocks.filter(block => block.type === 'problem' || block.type === 'video')
    });
  }
  return /*#__PURE__*/React.createElement(AspectsSidebar, {
    title: unitTitle,
    blockType: BlockTypes.vertical,
    dashboardId: blockId,
    contentLists: contentLists,
    blockActivatedCallback: block => sendMessageToIframe('scrollToXBlock', {
      locator: block.id
    })
  });
}